module.exports = __webpack_public_path__ + "static/media/em-121.3a6e3ef8.png";